import { Component } from '@angular/core';

@Component({
  selector: 'app-address',
  imports: [],
  templateUrl: './address.html'
})
export class Address {

}
